import type { MonthlyDateGranularity } from './resolveItemDayPosition';

const GRANULARITY_ORDER: Record<MonthlyDateGranularity, number> = {
  day: 0,
  month: 1,
  quarter: 2
};

export interface MonthlyTrackPlacementSortable {
  dateGranularity: MonthlyDateGranularity;
  chronologyMs: number;
  item?: { title?: string };
}

export function sortMonthlyTrackPlacementItems<
  T extends MonthlyTrackPlacementSortable
>(items: T[]): T[] {
  return [...items].sort((a, b) => {
    const granularityDiff =
      GRANULARITY_ORDER[a.dateGranularity] -
      GRANULARITY_ORDER[b.dateGranularity];
    if (granularityDiff !== 0) return granularityDiff;

    if (a.chronologyMs !== b.chronologyMs) {
      return a.chronologyMs - b.chronologyMs;
    }

    return (a.item?.title || '').localeCompare(b.item?.title || '');
  });
}
